<script>
export default {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    iconfont: {
      type: String,
      default: "",
    },
  },
  render(h, context) {
    const { icon, title, iconfont } = context.props;
    const vnodes = [];

    if (icon) {
      vnodes.push(<i class={icon} />);
    }

    if (iconfont) {
      const iconfontClass = "iconfont " + iconfont;
      vnodes.push(<i class={iconfontClass} />);
    }

    if (title) {
      vnodes.push(<span slot="title">{title}</span>);
    }
    return vnodes;
  },
};
</script>
